module.exports = __webpack_public_path__ + "media/images/fav-06a727b3172c17d09d19f94e8ffd02de.png";